// extracted by mini-css-extract-plugin
module.exports = {"section":"-mdz6SVjQc","header":"_22cJcUndwQ","content":"_39ik4kGmqD","title":"_3BYTdZDnsv","description":"_3Xg72PH4L_","expand-button":"_38tEj848gj","expandButton":"_38tEj848gj"};
    if(module.hot) {
      // 1597843267042
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  